<template>
<div class="wpa_wrap">
        <iframe
            :src="iframeURL"
            frameborder="0"
            id="wps_iframe"
            class="wps_iframe"
            ref="wpsIframe"
            allowfullscreen
            allow="clipboard-read; clipboard-write"
        ></iframe>
    </div>
</template>

<script lang="ts">
import { mapActions, mapState, mapGetters } from 'vuex';
import { switchLang } from '../../utils/lang';
import { getBrowser } from '../../utils/browser';
import { clearCookieAndToLogin } from '../../login';
import { reportFirstScreen } from '@/utils/reportFirstScreen';
export default {
    name: '',
    emits: [
        'gotoFile',
        'deleteFile',
        'gotoUseTemplate',
        'saveFileFinished',
        'createCopy',
        'moveFile',
        'handleOpen'
    ],
    components: {},
    data() {
        return {};
    },
    mounted() {
        console.log('wps wrap mounted', new Date().getTime());
        let iframeDom = document.getElementById('wps_iframe');
        iframeDom = document.querySelector('.wps_iframe');
        iframeDom.allow = 'clipboard-read; clipboard-write';
        iframeDom.onload = () => {
            console.timeEnd('wps wrap 加载耗时');
        };
        console.time('wps wrap 加载耗时');

        //wps通信
        window.addEventListener('message', this.handleMessage);
    },
    onmounted() {
        window.removeEventListener('message', this.handleMessage);
    },
    computed: {
        ...mapState({
            doc_id: state => state.kbModule.doc_id,
            doc_type: state => state.kbModule.doc_type,
            doc_info: state => state.kbEditModule.doc_info,
            isKBDirExpand: state => state.kbTreeNodeModule.isKBDirExpand,
            curSelectedTreeNodes: state =>
                state.kbTreeNodeModule.curSelectedTreeNodes,
            showtype: (state: any) => state.kbModule.showtype,
            userInfo: (state: any) => state.userModule,
            wikiI18n: (state: any) => state.kbModule.wikiI18n
        }),
        iframeURL() {
            if (
                this.doc_type == 'PPT' ||
                this.doc_type == 'EXCEL' ||
                this.doc_type == 'WORD'
            ) {
                reportFirstScreen();
                let localUrl = window.location.href;
                let source = null;
                if (localUrl.length > 0) {
                    const searchParams = new URL(localUrl).searchParams;
                    source = searchParams.get('source');
                }
                const isSourceHome = source && source === 'home';
                if (
                    getBrowser().isInTocaApp === true &&
                    isSourceHome === true
                ) {
                    //pc端内打开并且参数携带source=home的时候  wps连接拼接上source=wikiHome
                    return `${
                        import.meta.env.VITE_APP_GATE_WAY_URL
                    }/cloud?fid=${this.doc_id}&source=wikiHome&showtype=${
                        this.showtype
                    }&lang=${this.wikiI18n}`;
                } else {
                    return `${
                        import.meta.env.VITE_APP_GATE_WAY_URL
                    }/cloud?fid=${this.doc_id}&source=wiki&showtype=${
                        this.showtype
                    }&lang=${this.wikiI18n}`;
                }
            } else {
                return ``;
            }
        }
    },
    methods: {
        ...mapActions({
            setKBDirExpand: 'kbTreeNodeModule/setKBDirExpand'
        }),

        handleMessage(event) {
            console.log('----------------kb', event);
            if (event.source !== this.$refs.wpsIframe.contentWindow) return;
            const message = event.data;
            if (message === 'expandKBDir') {
                this.setKBDirExpand(true);
            } else if (message === 'starFile') {
                this.curSelectedTreeNodes.star = true;
            } else if (message === 'unstarFile') {
                this.curSelectedTreeNodes.star = false;
            } else if (message === 'createCopy') {
                this.$emit('createCopy', {
                    ...this.doc_info,
                    ...this.doc_info.fileInfo
                });
            } else if (message.type === 'saveFileFinished') {
                this.$emit('saveFileFinished', message.data);
            } else if (message === 'moveFile') {
                this.$emit('moveFile', {
                    ...this.doc_info,
                    ...this.doc_info.fileInfo
                });
            } else if (message.type === 'gotoFile') {
                let fileId = message.fileId;
                if (fileId) {
                    this.$emit('gotoFile', fileId);
                }
            } else if (message.type === 'deleteFile') {
                let fileId = message.fileId;
                if (fileId) {
                    this.$emit('deleteFile', fileId);
                }
            } else if (message.type === 'switchLang') {
                switchLang(message.data);
            } else if (message === 'logout') {
                clearCookieAndToLogin(true);
                console.log('退出登录');
            } else if (message === 'home-close') {
                window.close();
            } else if (message.type === 'gotoUseTemplate') {
                let templateId = message.templateId;
                this.$emit('gotoUseTemplate', templateId);
            } else if (message === 'handleOpen') {
                this.$emit('handleOpen');
            }
        },
        sendMessageToWps(message) {
            let src = this.$refs.wpsIframe.src;
            if (src.includes('cloud')) {
                let iframeWindow = this.$refs.wpsIframe.contentWindow;
                if (iframeWindow) {
                    iframeWindow.postMessage(message, this.iframeURL);
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.wpa_wrap {
    position: relative;
    flex: 1;
    display: flex;

    iframe {
        flex: 1;
    }
}
</style>
